import React from 'react';
import { LayoutDashboard, Users, Building, FileText, ArrowLeft, Phone, Mail, Calendar, Clock, CheckCircle } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link, useParams } from 'react-router-dom';
export function LeadDetailPage() {
  const {
    id
  } = useParams();
  const navItems = [{
    label: 'Overview',
    icon: LayoutDashboard,
    path: '/dashboard/developer'
  }, {
    label: 'Inventory',
    icon: Building,
    path: '/developer/inventory'
  }, {
    label: 'Leads & CRM',
    icon: Users,
    path: '/developer/leads'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/developer/reports'
  }];
  return <DashboardLayout title="Developer Console" personaLabel="DEVELOPER" personaColor="bg-blue-100 text-blue-800 border-blue-200" navItems={navItems} userInitials="DL" data-id="element-3858">
      <div className="mb-6" data-id="element-3859">
        <Link to="/developer/leads" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#1f2933] mb-4" data-id="element-3860">
          <ArrowLeft className="w-4 h-4" data-id="element-3861" /> Back to Leads
        </Link>
        <div className="flex flex-col md:flex-row justify-between items-start gap-4" data-id="element-3862">
          <div data-id="element-3863">
            <h1 className="text-2xl font-bold mb-1" data-id="element-3864">Rohan Gupta</h1>
            <p className="text-gray-500 font-mono text-sm" data-id="element-3865">
              Lead ID: {id || 'LD-4492'} • High Intent
            </p>
          </div>
          <div className="flex gap-3" data-id="element-3866">
            <button className="px-4 py-2 border border-gray-300 bg-white text-sm font-bold hover:bg-gray-50" data-id="element-3867">
              Log Call
            </button>
            <button className="px-4 py-2 bg-green-600 text-white text-sm font-bold hover:bg-green-700" data-id="element-3868">
              Convert to Booking
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-3869">
        <div className="lg:col-span-2 space-y-8" data-id="element-3870">
          {/* Notes & Activity */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-3871">
            <div className="flex gap-4 border-b border-gray-200 mb-6" data-id="element-3872">
              <button className="pb-2 border-b-2 border-[#1f2933] font-bold text-sm" data-id="element-3873">
                Activity Log
              </button>
              <button className="pb-2 border-b-2 border-transparent text-gray-500 hover:text-gray-700 text-sm" data-id="element-3874">
                Notes
              </button>
              <button className="pb-2 border-b-2 border-transparent text-gray-500 hover:text-gray-700 text-sm" data-id="element-3875">
                Files
              </button>
            </div>

            <div className="space-y-6 relative before:absolute before:left-2 before:top-2 before:bottom-2 before:w-0.5 before:bg-gray-200" data-id="element-3876">
              {[{
              type: 'Site Visit',
              desc: 'Visited Green Valley Phase 1. Liked Plot A-101.',
              time: 'Yesterday, 4:00 PM',
              icon: Users
            }, {
              type: 'Call Logged',
              desc: 'Discussed pricing. Customer asked for 5% discount.',
              time: 'Oct 22, 11:30 AM',
              icon: Phone
            }, {
              type: 'Inquiry',
              desc: 'New inquiry received via Website.',
              time: 'Oct 20, 9:00 AM',
              icon: Mail
            }].map((act, i) => <div key={i} className="relative pl-8" data-id="element-3877">
                  <div className="absolute left-0 top-0 w-4 h-4 bg-white border-2 border-gray-400 rounded-full" data-id="element-3878"></div>
                  <h4 className="font-bold text-sm" data-id="element-3879">{act.type}</h4>
                  <p className="text-sm text-gray-600 mt-1" data-id="element-3880">{act.desc}</p>
                  <span className="text-xs text-gray-400 mt-1 block" data-id="element-3881">
                    {act.time}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        <div className="space-y-6" data-id="element-3882">
          {/* Contact Info */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-3883">
            <h3 className="font-bold text-sm uppercase text-gray-500 mb-4" data-id="element-3884">
              Contact Details
            </h3>
            <div className="space-y-3" data-id="element-3885">
              <div className="flex items-center gap-3" data-id="element-3886">
                <Phone className="w-4 h-4 text-gray-400" data-id="element-3887" />
                <span className="text-sm font-mono" data-id="element-3888">+91 98765 43210</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-3889">
                <Mail className="w-4 h-4 text-gray-400" data-id="element-3890" />
                <span className="text-sm font-mono" data-id="element-3891">rohan.g@example.com</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-3892">
                <Users className="w-4 h-4 text-gray-400" data-id="element-3893" />
                <span className="text-sm" data-id="element-3894">Pune, Maharashtra</span>
              </div>
            </div>
          </div>

          {/* Interest */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-3895">
            <h3 className="font-bold text-sm uppercase text-gray-500 mb-4" data-id="element-3896">
              Interested In
            </h3>
            <div className="p-3 border border-gray-200 bg-gray-50 mb-3" data-id="element-3897">
              <div className="font-bold text-sm" data-id="element-3898">Green Valley Phase 1</div>
              <div className="text-xs text-gray-500" data-id="element-3899">
                Plot A-101 • 2,400 Sq.Ft
              </div>
              <div className="font-bold text-sm mt-1" data-id="element-3900">₹ 45 Lakhs</div>
            </div>
            <div className="flex items-center gap-2 text-xs text-green-600 font-bold" data-id="element-3901">
              <CheckCircle className="w-4 h-4" data-id="element-3902" /> Budget Matches
            </div>
          </div>

          {/* Next Action */}
          <div className="bg-blue-50 border border-blue-100 p-6" data-id="element-3903">
            <h3 className="font-bold text-sm text-blue-900 mb-2 flex items-center gap-2" data-id="element-3904">
              <Clock className="w-4 h-4" data-id="element-3905" /> Next Follow-up
            </h3>
            <p className="text-sm text-blue-800 mb-4" data-id="element-3906">
              Scheduled call for negotiation on Oct 25, 10:00 AM.
            </p>
            <button className="w-full py-2 bg-white border border-blue-200 text-blue-700 text-xs font-bold hover:bg-blue-50" data-id="element-3907">
              Reschedule
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}